import React from 'react';
import BrandDetailsContent from '../../../components/Dashboard/BrandsListContent/View';
import { Link } from 'react-router-dom';

function BrandDetails() {
    return (
        <>
          {/* Breadcrumb */}
          {/* <div className="breadcrumb-card">
            <h5>Brands </h5>
            <ul className="breadcrumb">
              <li>
                <Link to="/dashboard/ecommerce/">
                  <i className="material-symbols-outlined">home</i>
                  Dashboard
                </Link>
              </li>
              <li>Brands</li>
              <li>Brand Details</li>
            </ul> 
          </div> */}
            
          <BrandDetailsContent />
        </>
      );
}

export default BrandDetails
